import React, { Component } from 'react';
import Dropdown from 'react-dropdown';
import CheckboxParameter from './CheckboxParameter.js';
import ResolutionDropdown from './ResolutionDropdown.js';
import DrawComponent from 'components/draw/DrawComponent.js';
import ConditionedComponent from 'components/ConditionedComponent.js';
import EffectParameterSlider from './EffectParameterSlider.js';
import {setContextualHelp} from "actions/index.js";
import { connect } from "react-redux";

class ChordSculptorEffect extends Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    isEnabled() {
        return this.props.automation !== undefined ? true :
            this.props.effect.isEnabled();
    }

    render() {
        return (
            <div>
              <ConditionedComponent condition={this.isEnabled()}>
                <div className="clear-fix"/>
                <DrawComponent lines={this.props.effect.rawLines}
                               onLinesChanged={(lines) => this.props.effect.linesParameter.set(lines)}/>
            </ConditionedComponent>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch, props) => {
    return {
        setContextualHelp: (element) => dispatch(setContextualHelp(element)),
    };
}
 
export default connect(null, mapDispatchToProps)(ChordSculptorEffect);
